import { useReferralStageList } from '@/features/points-management/points-configuration/customerTable/referralStage/hooks/useReferralStageList';
import { ReferralStageTable } from '@/features/points-management/points-configuration/customerTable/referralStage/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['stageTitle', 'createdBy', 'createdDate', 'status']),
  desc: z.boolean(),
});

const ReferralStageSearchSchema = z.object({
  breadcrumbReturnTo: z.string().optional(),
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  createdDate: z.string().optional(),
  q: z
    .any()
    .optional()
    .transform((val) => (val == null ? undefined : String(val))),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});
export const Route = createFileRoute('/(app)/points-management/points-configuration/customer/$programId/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => ReferralStageSearchSchema.parse(search),
});

function RouteComponent() {
  const { referralStage, loading, pagination } = useReferralStageList();
  return <ReferralStageTable data={referralStage} isLoading={loading} pagination={pagination} />;
}
